export const EDITOR_STATE_DRAFT_VERSION = 1;
export const EDITOR_STATE_DRAFT_KEY_PREFIX = 'EDITOR_STATE_DRAFT';